import { useParams } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import { removeUserVariables, useRemoveUserFromGroup } from './useRemoveUserFromGroup';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { UseMutateFunction, useQueryClient } from 'react-query';
import { GroupDto, UsersApi } from '../../../api-client';
import { getApiConfiguration } from '../../../common';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseDeleteUserFromGroupModalFacade = () => {
  userGroupToDelete: false | (GroupDto & { documentId: string });
  setUserGroupToDelete: React.Dispatch<
    React.SetStateAction<false | (GroupDto & { documentId: string })>
  >;
  removeUserFromGroup: UseMutateFunction<AxiosResponse<void>, ErrorResponse, removeUserVariables>;
  isRemoving: boolean;
  closeUserGroupDeleteModal: () => void;
};

export const useDeleteUserFromGroupModalFacade: UseDeleteUserFromGroupModalFacade = () => {
  const { id } = useParams<{ id: string }>();
  const { showNotification } = useContext(NotificationsContext);
  const queryClient = useQueryClient();
  const usersApi = new UsersApi(getApiConfiguration());
  const [userGroupToDelete, setUserGroupToDelete] = useState<
    false | (GroupDto & { documentId: string })
  >(false);

  const { mutate: removeUserFromGroup, isLoading: isRemoving } = useRemoveUserFromGroup(usersApi, {
    onSuccess: () => {
      showNotification('User successfully removed from the group');
      queryClient.invalidateQueries(`user-${id}-groups`).then();
      closeUserGroupDeleteModal();
    },
    onError: () => {
      showNotification('An error occurred while removing user to group. Please try again');
    },
  });

  const closeUserGroupDeleteModal = () => {
    setUserGroupToDelete(false);
  };

  return {
    userGroupToDelete,
    setUserGroupToDelete,
    removeUserFromGroup,
    isRemoving,
    closeUserGroupDeleteModal,
  };
};
